/* eslint-disable react/prop-types */

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

/* ---------- helpers ---------- */

const getInitials = (fullName = "") => {
  const parts = fullName.trim().split(" ");
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

/* ---------- cell components ---------- */

const Author = ({ name, reportsTo }) => (
  <MDBox display="flex" alignItems="center">
    <MDBox
      sx={{
        backgroundColor: "#e2e2e2",
        borderRadius: "50%",
        height: 40,
        width: 40,
        lineHeight: "40px",
        textAlign: "center",
        fontWeight: "bold",
      }}
    >
      {getInitials(name)}
    </MDBox>

    <MDBox ml={2} display="flex" flexDirection="column" alignItems="flex-start">
      <MDTypography variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="caption" color="text">
        Reports to {reportsTo}
      </MDTypography>
    </MDBox>
  </MDBox>
);

const NumberCell = ({ value }) => (
  <MDTypography variant="caption" fontWeight="medium">
    {value}
  </MDTypography>
);

/* ---------- main export ---------- */

export default function callReportTableData(apiData = []) {
  // console.log(apiData);
  return {
    columns: [
      { Header: "Employee", accessor: "author", align: "left" },
      //   { Header: "Reports To", accessor: "function", align: "left" },
      { Header: "Connected Calls", accessor: "status", align: "center" },
      { Header: "Dialed Calls", accessor: "dialed", align: "center" },
      { Header: "Avg Call Duration (min)", accessor: "employed", align: "center" },
      { Header: "Assigned Cold Calls", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      author: <Author name={item?.callBy?.name || "-"} reportsTo={item?.reportsTo?.name || "-"} />,

      function: <MDTypography variant="caption">{item?.reportsTo?.name || "-"}</MDTypography>,

      status: <NumberCell value={item?.callSummary?.connectedCall ?? 0} />,

      dialed: <NumberCell value={item?.callSummary?.completedCall ?? 0} />,

      employed: <NumberCell value={item?.callSummary?.avg} />,

      action: (
        <NumberCell value={item?.callSummary?.totalAssignedCount ?? 0} />
        // <MDBadge
        //   badgeContent={item?.callSummary?.totalAssignedCount ?? 0}
        //   color="info"
        //   variant="gradient"
        //   size="sm"
        // />
      ),
    })),
  };
}
